import { getNoteGenerationEngineConfig } from '../../config';

export function openNoteStructurePicker(): void {
  getNoteGenerationEngineConfig().reactions.openNoteStructurePicker();
}

export function reopenNoteStructurePickerForRecovery(): void {
  getNoteGenerationEngineConfig().reactions.reopenNoteStructurePickerForRecovery();
}

export function openDelayUpgradeModalForStreamQuota(): void {
  getNoteGenerationEngineConfig().reactions.openDelayUpgradeModalForStreamQuota();
}

export function markPickerOutOfProActions(): void {
  getNoteGenerationEngineConfig().reactions.markPickerOutOfProActions();
}

/** Preserve the body's eager default decision between the first and second writes. */
export function showPickerUnavailableTemplateBanner(producers: {
  templateId: () => string | null;
  computeWasDefault: () => boolean;
}): void {
  getNoteGenerationEngineConfig().reactions.showPickerUnavailableTemplateBanner(
    producers
  );
}
